import axios from 'axios'

export default {
    namespaced: true,
    state: {
        bursaries: [],
        bursary: {},
        bursaryFundingPaymentDetails: [],
        bursaryPayments: [],
    },
    mutations: {
        SET_BURSARIES(state, payload) {
            state.bursaries = payload;
        },
        SET_BURSARY(state, payload) {
            state.bursary = payload;
        },
        SET_BURSARYFUNDINGPAYMENTDETAILS(state, payload) {
            state.bursaryFundingPaymentDetails = payload;
        },
        SET_BURSARYPAYMENTS(state, payload) {
            state.bursaryPayments = payload;
        },
    },
    actions: {
        FetchBursaries({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/bursaries/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_BURSARIES', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchBursaries: ${error.message}`));
            });
        },
        UpdateBursaryLearningAgreement({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/bursaries/update/learning-agreement`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateBursaryLearningAgreement: ${error.message}`));
            });
        },
        FetchBursary({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/bursaries/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_BURSARY', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchBursary: ${error.response.data || error.message}`));
            });
        },
        FetchBursaryFundingPaymentDetailsByBursaryIDs({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/bursaries/funding-payment-details/fetch/bursary-ids`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_BURSARYFUNDINGPAYMENTDETAILS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchBursaryFundingPaymentDetailsByBursaryIDs: ${error.response.data || error.message}`));
            });
        },
        FetchBursaryFundingPaymentDetailsByBursaryID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/bursaries/funding-payment-details/fetch/bursary-id`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_BURSARYFUNDINGPAYMENTDETAILS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchBursaryFundingPaymentDetailsByBursaryID: ${error.response.data || error.message}`));
            });
        },
        FetchBursaryPaymentsByBursaryID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/bursaries/payments/fetch/bursary-id`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_BURSARYPAYMENTS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchBursaryPaymentsByBursaryID: ${error.response.data || error.message}`));
            });
        },
    },
    getters: {
        Bursaries(state) { return state.bursaries; },
        Bursary(state) { return state.bursary; },
        BursaryFundingPaymentDetails(state) { return state.bursaryFundingPaymentDetails; },
        BursaryPayments(state) { return state.bursaryPayments; },
    }
};
